import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22.5 7.5L7.5 22.5M22.5 22.5L7.5 7.5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClose;
